<template>
  <nt-template>
    <v-row dense justify="center">
      <v-col cols="12" sm="10" md="8" lg="6">
        <v-card>
          <v-card-text class="text-center">
            <h3 class="text-h5 mt-4 mb-0 text-center">
              Assinatura de Plano
            </h3>
          </v-card-text>
          <v-card-text>
            <template v-if="course_package">
              <h3 class="text-center">Pacote de curso: {{ course_package.name }}</h3>

              <v-row dense justify="center" class="py-3">
                <v-col cols="12" md="6" lg="4" v-for="course in course_package.courses" :key="course.id">
                  <v-card class="elevation-0 grey lighten-3">
                    <v-card-text class="text-center">{{ course.name }}</v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12" class="text-center">
                  <h1>{{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(course_package.amount) }}</h1>
                  <h4 v-if="course_package.plan.trial_days">
                    Você ganha {{ course_package.plan.trial_days }} dias de avaliação
                  </h4>
                </v-col>
              </v-row>
            </template>
          </v-card-text>
          <v-card-text>
            <v-row dense>
              <template v-if="isAuthenticated && course_package">
                <v-col cols="12">
                  <payment type="PLAN" :item="course_package"/>
                </v-col>
              </template>
              <template v-else>
                <v-col cols="12" lg="6">
                  <v-btn large depressed dark block color="green" @click="toLogin">
                    Prosseguir com o login
                  </v-btn>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-btn large depressed dark block color="green" @click="toRegister">
                    Cadastrar
                  </v-btn>
                </v-col>
              </template>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </nt-template>
</template>

<script>
import { CoursePackage } from '@/services/resources'
import NtTemplate from '@/components/Utils/NtTemplate'
import Payment from '@/components/Payment/Index'
import { mapActions, mapGetters } from 'vuex'

export default {
  mounted () {
    CoursePackage.show(this.$route.params.package).then((response) => {
      this.course_package = response.body
    })
  },
  components: {
    NtTemplate,
    Payment
  },
  data () {
    return {
      course_package: null
    }
  },
  methods: {
    toLogin () {
      this.changeNextLogin(`/plan/${this.$route.params.package}`)
      this.$router.push({ name: 'auth.login' })
    },
    toRegister () {
      this.changeNextLogin(`/plan/${this.$route.params.package}`)
      this.$router.push({ name: 'auth.register' })
    },
    ...mapActions({
      changeNextLogin: 'App/changeNextLogin'
    })
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'App/isAuthenticated'
    })
  }
}
</script>
